import React from 'react'
import { Box } from '@mui/material'

interface ILightBackgroundProps {
  children: React.ReactNode
}

const LightBackground: React.FC<ILightBackgroundProps> = ({ children }) => {
  return (
    <Box
      component="div"
      sx={{
        backgroundColor: (theme) => theme.palette.bw.backgroundColor,
        width: '100%',
        padding: (theme) => theme.spacing(60, 0),
        '@media (max-width: 1000px)': {
          padding: (theme) => theme.spacing(40, 0),
        },
        '@media (max-width: 600px)': {
          padding: (theme) => theme.spacing(20, 0),
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  )
}

export default LightBackground
